<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-tag label="Byteliberi di Paolo Proni" kind="teal" style="width: 100vw; margin-bottom: 1em;"></cv-tag>
    <cv-tabs :container="false" aria-label="navigation tab label">
      <!-- Dati generali sul lavoro svolto -->
      <cv-tab id="tab-1" label="Dati Principali">
        <cv-grid fullWidth> <!-- sm: 4 md: 8 lg: 16 -->
          <cv-row>
              <cv-column :sm="2" :md="4" :lg="3">
                <data-valida etichetta="Data Lavoro"
                             v-model="lavoro.dta_lavoro"
                             messaggio_non_valido="Data del lavoro non valida">

                </data-valida>
              </cv-column>
              <cv-column :sm="2" :md="4" :lg="3">
                <data-valida etichetta="Data Registrazione" readonly
                             v-model="lavoro.dta_registrazione" />
              </cv-column>
              <cv-column :sm="2" :md="4" :lg="3">
                <data-valida etichetta="Data Pagamento"
                             v-model="lavoro.dta_pagamento"
                             messaggio_non_valido="Data di pagamento non valida" />
              </cv-column>
              <cv-column :sm="2" :md="4" :lg="4">
                <cv-text-input label="Stato della Fatturazione"
                               :value="status_Fattura" readonly />
              </cv-column>
          </cv-row>
          <cv-row>
            <cv-column :sm="4" :md="8" :lg="8">
              <cv-combo-box label="Seleziona un cliente"
                            title="Cliente" :auto-filter="true"
                            value="Azienda Agricola Mario Rossi s.r.l"
                            :options="options"></cv-combo-box>
            </cv-column>
            <cv-column :sm="4" :md="8" :lg="8">
              <cv-text-input label="Descrizione"
                             value="Estrazione bietole + carico"></cv-text-input>
            </cv-column>
          </cv-row>
          <cv-row>
            <cv-column :sm="4" :md="8" :lg="8">
              <cv-combo-box label="Seleziona una coltura"
                            :auto-filter="true"
                            title="Coltura" value="Barbabietole"
                            :options="options_colture"></cv-combo-box>
            </cv-column>
            <cv-column :sm="4" :md="8" :lg="8">
              <cv-combo-box label="Seleziona un fondo"
                            :auto-filter="true"
                            title="Fondo" value="Russi"
                            :options="options_fondi"></cv-combo-box>
            </cv-column>
          </cv-row>
          <cv-row>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-combo-box label="Seleziona" title="Unità di misura"
                            value="Ettari (HA)" :auto-filter="true"
                            :options="options_um"></cv-combo-box>
            </cv-column>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-number-input label="Quantità" title="Quantità" value="1"></cv-number-input>
            </cv-column>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-text-input label="Tariffa" title="Tariffa" value="€ 200,00"></cv-text-input>
            </cv-column>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-text-input label="Imponibile" title="Imponibile" value="€ 200,00" readonly></cv-text-input>
            </cv-column>
          </cv-row>
          <cv-row>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-number-input label="% IVA" title="% IVA" value="10"></cv-number-input>
            </cv-column>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-number-input label="% Sconto" title="% Sconto" value="0"></cv-number-input>
            </cv-column>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-text-input label="Sconto" title="Sconto" value="€ 0"></cv-text-input>
            </cv-column>
            <cv-column :sm="4" :md="4" :lg="4">
              <cv-text-input label="Totale da Fatturare" readonly
                             title="Totale da Fatturare" value="€ 220,00"></cv-text-input>
            </cv-column>
          </cv-row>
        </cv-grid>
      </cv-tab>
      <!-- Dati sulle macchine impiegate -->
      <cv-tab id="tab-2" label="Macchine">
        <cv-grid>
          <cv-row>
            <cv-column :sm="2" :md="3" :lg="3">
              <cv-text-input label="Consumo per Unità di Misura"
                             title="Consumo"
                             value="€ 100,00"></cv-text-input>
            </cv-column>
          </cv-row>
          <cv-row>
            <cv-column :sm="4" :md="8" :lg="16">
              <cv-data-table :columns="colonne_macchine"
                             :data="macchine_filtrate"
                             helper-text="Macchine utilizzate in questo lavoro"
                             title="Macchine">

              </cv-data-table>
            </cv-column>
          </cv-row>
        </cv-grid>
      </cv-tab>
      <!-- Dati sugli operai impiegati in questo lavoro -->
      <cv-tab id="tab-3" label="Operai">
        <cv-grid>
          <cv-row>
            <cv-column :sm="4" :md="8" :lg="16">
              <cv-data-table :columns="colonne_operai"
                             :data="operai_filtrati"
                             helper-text="Operai impiegati in questo lavoro"
                             title="Operai">
              </cv-data-table>
            </cv-column>
          </cv-row>
        </cv-grid>
      </cv-tab>
      <cv-tab id="tab-4" label="Note">
        <cv-grid>
          <cv-row>
            <cv-column :sm="4" :md="8" :lg="16">
              <cv-text-area
                  label="Annotazioni"
                  value="E' andato tutto bene"></cv-text-area>
            </cv-column>
          </cv-row>
        </cv-grid>
      </cv-tab>
    </cv-tabs>
    <hr/>
    <Bottoniera testo_nuovo="Nuovo Lavoro"
                testo_salva="Salva Lavoro"
                :stato="this.$statiPossibili.non_modificato"
                v-on:salva-premuto="$emit('bottone-premuto')"
                v-on:nuovo-premuto="$emit('bottone-premuto')"
                v-on:duplica-premuto="$emit('bottone-premuto')"
                v-on:primo-premuto="$emit('bottone-premuto')"
                v-on:precedente-premuto="$emit('bottone-premuto')"
                v-on:successivo-premuto="$emit('bottone-premuto')"
                v-on:ultimo-premuto="$emit('bottone-premuto')"
                v-on:visualizzazione-premuto="$emit('bottone-premuto')"
                v-on:filtra-premuto="$emit('bottone-premuto')"
                v-on:cancella-premuto="$emit('bottone-premuto')" >
      <template v-slot:btn1>
        <cv-tooltip tip="Carica un lavoro tipo e copia i valori dei suoi campi su questo lavoro.">
          <cv-button kind="secondary"
                     @click="$emit('bottone-premuto')"
                     :icon="svg_lavoro_tipo"
                     style="margin-right: 1em;">Lavoro Tipo</cv-button>
        </cv-tooltip>
      </template>
      <template v-slot:btn2>
        <cv-tooltip tip="Crea una fattura singola per questo lavoro">
          <cv-button kind="tertiary"
                     @click="$emit('bottone-premuto')"
                     :icon="svg_fattura">Fatturalo</cv-button>
        </cv-tooltip>
      </template>
    </Bottoniera>

  </cv-content>
</template>

<script>
import Bottoniera from "@/components/Bottoniera";
import DocumentIco from '@carbon/icons-vue/es/document/16';
import Types from '@carbon/icons-vue/es/types/16';

export default {
  name: "Lavori",
  components: {Bottoniera},
  methods: {
    mostra: function () {
      console.log(this.lavoro.dta_lavoro);
    },
    actionClose: function () {
      this.notifica_visibile = false;
    }
  },
  data: function () {
    return {
      use_actions: true,
      notifica_visibile: false,
      lavoro: {
        dta_lavoro: "11/08/2020",
        dta_registrazione: "12/08/2020",
        dta_pagamento: "13/08/2020"
      },
      svg_fattura: DocumentIco,
      svg_lavoro_tipo: Types,
      status_Fattura: "Già fatturato",
      colonne_operai: [
        "Nome",
        "Ore"
      ],
      operai_filtrati: [
        [
          "Paolo",
          "8"
        ],
        [
          "Gigi",
          "4"
        ],
      ],
      colonne_macchine: [
        "Descrizione",
        "Targa",
        "Ore"
      ],
      macchine_filtrate: [
        [
          "FENDT",
          "AB 123 CD",
          "100"
        ],
        [
          "FIAT",
          "EF 456 GH",
          "50"
        ],
        [
          "SAME",
          "IL 789 MN",
          "10"
        ],
      ],
      options: [
        {
          value: "1",
          label: "Azienda Agricola Mario Rossi s.r.l",
          name: "Azienda Agricola Mario Rossi s.r.l"
        },
        {
          value: "2",
          label: "Paolo Verdi s.r.l",
          name: "Paolo Verdi s.r.l"
        }
      ],
      options_colture: [
        {
          value: "1",
          label: "Barbabietole",
          name: "Barbabietole"
        },
        {
          value: "2",
          label: "Grano",
          name: "Grano"
        }
      ],
      options_fondi: [
        {
          value: "1",
          label: "Fusignano",
          name: "Fusignano"
        },
        {
          value: "2",
          label: "Russi",
          name: "Russi"
        }
      ],
      options_um: [
        {
          value: "1",
          label: "Ettari (HA)",
          name: "Ettari (HA)"
        },
        {
          value: "2",
          label: "Ore",
          name: "Ore"
        }
      ]
    }
  }
}
</script>

<style lang="scss">
 @import '../../styles/carbon';


#main-content {
  background-color: $ui-background;
  color: $text-01;
//  padding-left: 6rem;

//  height: 100vh;
  height: 2000px;

//  width: 100vw;

//  margin-top: 0px;
//  padding-top: 1rem;

}

 .cv-row {
    padding: 0.5em;
 }
</style>